const messages = {
    en: {
        subjEditSuccess: "Subject has been edited successfully",
        subjdeleteSuccess: "Subject has been deleted successfully",
        subjAddSuccess: "Subject has been added successfully",
    },
    ru: {
        subjEditSuccess: "Предмет успешно отредактирован",
        subjdeleteSuccess: "Предмет успешно удален",
        subjAddSuccess: "Предмет успешно добавлен",
    }
  };

  export default messages;